module.exports = __webpack_public_path__ + "static/media/Salerno80x80Porclain2.64b647bb.jpg";